import { AccountBalance } from 'data/Account/types'
import { ApiCurrency, CurrencyProduct } from 'data/Currencies/types'
import { CurrencyDefinitionType } from 'data/types'

type CurrenciesData = {
  assetCurrencies: ApiCurrency[]
  balances: AccountBalance
  instrumentCurrencies: CurrencyDefinitionType[]
  paymentCurrencies: string[]
}
export default function getFiatWithdrawOptions({
  assetCurrencies,
  balances,
  instrumentCurrencies,
  paymentCurrencies
}: CurrenciesData) {
  return assetCurrencies
    .filter(({ type }) => type.name === 'FIAT')
    .filter((c) => c.products.includes(CurrencyProduct.MercuryWithdrawals))
    .filter((c) => paymentCurrencies.includes(c.symbol))
    .filter((c) => instrumentCurrencies.some((ic) => ic.key === c.symbol && !ic.blocked))
    .filter((cur) => balances && Number(balances[cur.symbol]?.withdrawable) > 0)
}
